import { UseEvent, UseNavigation } from "./index";
import { useDimension } from "lb-components";
import UseUser from "./useUser";
import { useRef, useState } from "react";

const UseBottomBar = (callback) => {
  let bottomNavRef = null;
  let backDropRef = null;
  let contentRef = null;
  let firstTouch = 0;
  let enable = false;
  let clientHeight = window.innerHeight;
  let height = 0;
  let direction = null;
  let nav = null;
  let navRoute = null;
  const bottomBarListener = UseEvent();
  const { updateBalance } = UseUser();

  const addListener = ({ ref, backRef, contRef, navRefs, setRoute }) => {
    nav = UseNavigation();
    bottomNavRef = ref?.current;
    backDropRef = backRef?.current;
    contentRef = contRef?.current;
    navRoute = setRoute;

    /*document.addEventListener("resize", () => {
      clientHeight = window.innerHeight;
    });*/

    document.addEventListener("touchstart", (evt) => {
      return;
      try {
        if (
          navRefs?.backdropRef?.current.contains(evt.target) ||
          navRefs?.navContentRef?.current.contains(evt.target) ||
          contentRef.contains(evt.target)
        ) {
          enable = false;
          return;
        }

        firstTouch = (evt.touches || evt.originalEvent.touches)[0].clientY;
        enable =
          !contentRef.contains(evt.target) && height === 0
            ? firstTouch > clientHeight
            : true;
      } catch (e) {
        console.log(e);
      }
    });
    document.addEventListener(
      "touchmove",
      function (evt) {
        return;

        if (enable) {
          const translateY = (evt.touches || evt.originalEvent.touches)[0]
            .clientY;
          direction = firstTouch < translateY ? "down" : "up";
          if (direction === "up") {
            let tmp = translateY - firstTouch;
            if (
              firstTouch < clientHeight * 0.5 &&
              (tmp <= 0 || translateY <= 0) &&
              height > clientHeight * 0.9
            ) {
              height = clientHeight;
            } else {
              if (Math.abs(tmp) <= clientHeight) {
                height = Math.abs(tmp);
              }
            }
          } else {
            let tmp = translateY - firstTouch;
            height = tmp < 0 ? clientHeight : clientHeight - tmp;
          }
          updateHeight(false);
        }
      },
      false
    );
    document.addEventListener(
      "touchend",
      function ({ touches }) {
        return;

        enable = false;
        height =
          direction === "down"
            ? height < clientHeight * 0.8
              ? 0
              : clientHeight
            : height > clientHeight * 0.3
            ? clientHeight
            : 0;
        updateHeight();
      },
      false
    );
  };
  const unsubscribe = () => {
    document.removeEventListener("resize", (e) =>
      console.log("remove resize listener")
    );
    document.removeEventListener("touchstart", (e) =>
      console.log("remove touch listener")
    );
    document.removeEventListener("touchmove", (e) =>
      console.log("remove touchmove listener")
    );
    document.removeEventListener("touchend", (e) =>
      console.log("remove touchend listener")
    );
  };
  const Open = ({ route = null }) => {
    updateBalance();
    bottomBarListener.emit("bottomBar", {
      status: true,
      route: route,
    });
  };
  const Close = () => {
    bottomBarListener.emit("bottomBar", { status: false });
  };
  const toggle = ({ status, route, height }) => {
    if (route) {
      navRoute(route);
    }
    //height = status ? clientHeight : 0;

    if (!status && window.location.pathname.includes("user")) nav.navigate("/");

    updateHeight(true, status ? height : 0, { bottomNavRef, backDropRef });
  };
  const updateHeight = (
    transition = true,
    height,
    { bottomNavRef, backDropRef }
  ) => {
    //bottomNavRef.style.height = extHeight + "px";
    if (bottomNavRef && backDropRef) {
      bottomNavRef.style.height = height > 0 ? `${height}px` : 0;

      bottomNavRef.style.transition = !transition ? "unset" : "0.3s";
      /*let opacity = (height / clientHeight) * 0.5;*/
      let opacity = 0.5;
      /*backDropRef.style.width = extHeight === 0 ? 0 : "100vw";
      backDropRef.style.height = extHeight === 0 ? 0 : "100vh";
      backDropRef.style.zIndex = extHeight === 0 ? -1 : 1050;*/

      backDropRef.style.width = height > 0 ? "100vw" : 0;
      backDropRef.style.height = height > 0 ? "100vh" : 0;
      backDropRef.style.zIndex = height > 0 ? 1050 : -1;

      backDropRef.style.opacity = opacity;
    }

    //callback(extHeight);
  };
  const handleInput = (enter = true) => {
    const bottomBar = document.getElementById("bottomBar");
    if (!bottomBar) return;
    if (enter) {
      bottomBar.style.position = "sticky";
      bottomBar.style.top = "0";
      bottomBar.style.transition = null;
    } else {
      bottomBar.style.position = "fixed";
      bottomBar.style.top = null;
      bottomBar.style.transition = "all 0.3s ease 0s";
    }
  };
  return {
    unsubscribe,
    addListener,
    Open,
    Close,
    toggle,
    handleInput,
    bottomBarListener,
    updateHeight,
  };
};
export default UseBottomBar;
